<template>
  <div class="general-opening-hour-container">
    <div v-if="isMobile" class="mobile-box-title">
      {{ $getText('PRESENCE_GENERAL_OPENING_HOURS') }}
    </div>
    <h2 v-else>{{ $getText('PRESENCE_GENERAL_OPENING_HOURS') }}</h2>
    <template v-for="(subList, key) in splitGeneralOpeningHourData">
      <div
        :key="'table-' + key"
        :class="{
          'for-one-institution': subList.length === 1 && generalOpeningHoursForGuardian.length !== 1,
        }"
        class="table"
      >
        <div class="table-row header">
          <div class="table-cell weekday-header">
            {{ $getText('PRESENCE_WEEKDAY_LABEL') }}
          </div>
          <template v-if="generalOpeningHoursForGuardian.length === 1">
            <div class="table-cell institution-header">
              {{ $getText('PRESENCE_OPENING_HOURS') }}
            </div>
          </template>
          <template v-else>
            <div
              v-for="institutionOpeningHourData in subList"
              :key="institutionOpeningHourData.institutionCode"
              class="table-cell institution-header"
            >
              {{ getInstitutionName(institutionOpeningHourData.institutionCode) }}
            </div>
          </template>
        </div>
        <div v-for="index in 5" :key="index" class="table-row body">
          <div class="table-cell weekday-cell">
            {{ getDayName(index) }}
          </div>
          <div
            v-for="institutionOpeningHourData in subList"
            :key="'cell-' + institutionOpeningHourData.institutionCode"
            class="table-cell"
          >
            <template
              v-if="
                institutionOpeningHourData.openingHours.length > 0 &&
                institutionOpeningHourData.openingHours[index - 1].openTime !== ''
              "
            >
              {{ institutionOpeningHourData.openingHours[index - 1].openTime }}
              -
              {{ institutionOpeningHourData.openingHours[index - 1].closeTime }}
            </template>
            <template v-else>
              {{ $getText('PRESENCE_OPENING_HOUR_NOT_GIVEN') }}
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { types } from '../../store/types/types';
import dataFormat from '../../../shared/mixins/dataFormatMixin';
import { DateTimeUtil } from '../../../shared/utils/dateTimeUtil';

export default {
  mixins: [dataFormat],
  props: {
    selectedInstitutions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isMobile: types.GET_IS_MOBILE,
      generalOpeningHoursForGuardian: types.GET_GENERAL_OPENING_HOURS_FOR_GUARDIAN,
    }),
    splitGeneralOpeningHourData() {
      const chunk = this.isMobile ? 1 : 2;
      return this.splitDataToChunks(this.generalOpeningHoursForGuardian, chunk);
    },
  },
  methods: {
    getInstitutionName(institutionCode) {
      const inst = this.selectedInstitutions.find(institution => institution.institutionCode === institutionCode);
      if (inst) {
        return inst.name;
      }
      return '';
    },
    getDayName(index) {
      return DateTimeUtil.isoDateNumberToName(index);
    },
  },
};
</script>
<style lang="scss" scoped>
@use '../../../shared/assets/scss/core/variables' as *;
@use '../../../shared/assets/scss/core/breakpoints' as *;
@use '../../../shared/assets/scss/components/presence/presence' as *;
</style>
